import {Fragment} from 'react';
import {Link} from '@ezcater/tapas';
import {type Translate} from 'next-translate';
import useTranslation from 'next-translate/useTranslation';

import useTracking from '@/hooks/useTracking';

export type TrackedLink = {key: string; path: string};

export type TrackedLinksProps = {
  as?: 'li' | 'span';
  className?: string;
  links: TrackedLink[];
};

const routeLabel = (key: string, t: Translate) => t(`components.Footer.pathNames.${key}`);

const TrackedLinks: React.FC<TrackedLinksProps> = ({as: Tag = 'li', className, links}) => {
  const {t} = useTranslation('common');
  const tracker = useTracking();

  const handleClick = (link: TrackedLink) => (event: React.MouseEvent) => {
    tracker.trackClick(`footer-${link.path}`);

    if (link.key === 'doNotSellMyInfo' && (window as any).transcend) {
      (window as any).transcend.showConsentManager({viewState: 'DoNotSellExplainer'});
      event.preventDefault();
    }
  };

  return (
    <>
      {links.map(link => (
        <Fragment key={link.key}>
          <Tag>
            <Link className={className} href={link.path} onClick={handleClick(link)}>
              {routeLabel(link.key, t)}
            </Link>
          </Tag>
        </Fragment>
      ))}
    </>
  );
};

export default TrackedLinks;
